import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { recurringPaymentsProxy } from '../../../../recurringPaymentsProxy'
import MagnifyingGlassIcon from '../../../../../../../../shared/components/ui/icons/MagnifyingGlassIcon'
import { FilterByInput } from '../../FilterByInput/FilterByInput'
import { handleUpdate, handleSubmit } from './utils'

export function SearchBox (): ReactElement {
  const { filters } = useSnapshot(recurringPaymentsProxy, { sync: true })
  return (
    <div className="w-full h-10 my-3 mx-3 text-gray-600 border border-gray-200 rounded">
      <form className="flex flex-row " onSubmit={handleSubmit}>
        <button
          type="submit"
          className="ml-4 filter hover:contrast-200 active:contrast-125"
        >
          <MagnifyingGlassIcon />
        </button>

        <input
          type="search"
          name="search"
          placeholder="Search Invoice, Company or Name"
          className="bg-white flex-grow my-2 px-5 pr-10 text-sm focus:outline-none rounded"
          value={filters.search}
          onChange={handleUpdate}
        />

        <FilterByInput />
      </form>
    </div>
  )
}
